import PropTypes from 'prop-types';

import './Pipi.scss';

const Pipi = ({ isPatternSelected = false }) => (
  <div
      className="pipi"
      style={isPatternSelected ? undefined : { visibility: "hidden" }}
  />
)

Pipi.propTypes = {
  isPatternSelected: PropTypes.bool
}

export default Pipi;